const ID_TOKEN_KEY = "id_token";
const ID_REFRESH_TOKEN_KEY = "id_refresh_token";

// "Beni hatırla" işaretliyse token localStorage'da (tarayıcı kapanınca da kalır),
// değilse sessionStorage'da (sekme kapanınca silinir) tutulur.
const activeStorage = () =>
  window.sessionStorage.getItem(ID_TOKEN_KEY)
    ? window.sessionStorage
    : window.localStorage;

export const getToken = () => {
  return activeStorage().getItem(ID_TOKEN_KEY);
};

export const getRefreshToken = () => {
  return activeStorage().getItem(ID_REFRESH_TOKEN_KEY);
};

// remember verilmezse (token yenileme) mevcut saklama yeri korunur.
export const saveToken = (token, refreshToken, remember) => {
  const storage =
    remember === undefined
      ? activeStorage()
      : remember
        ? window.localStorage
        : window.sessionStorage;
  destroyToken();
  storage.setItem(ID_TOKEN_KEY, token);
  storage.setItem(ID_REFRESH_TOKEN_KEY, refreshToken);
};

export const destroyToken = () => {
  for (const storage of [window.localStorage, window.sessionStorage]) {
    storage.removeItem(ID_TOKEN_KEY);
    storage.removeItem(ID_REFRESH_TOKEN_KEY);
  }
};

export default { getToken, getRefreshToken, saveToken, destroyToken };
